import type { CheckoutSession, PaymentOption } from "@/types";

/** Resolve the single pre-selected option to display read-only. */
export function selectPreSelectedOption(
  session: CheckoutSession,
): PaymentOption | undefined {
  const options = session.paymentOptions ?? [];
  const byId = options.find((o) => o.offerId === session.selectedPaymentOptionId);
  if (byId) return byId;
  return options.length === 1 ? options[0] : undefined;
}
